module.exports = __webpack_public_path__ + "static/media/breakdownTable_mobile.05f0c771.png";